import { createContext, useContext } from 'react'

export type ToolbarContextValue = {
    objectSid: string
    searchQuery: string
    onChangeSearchQuery: (search: string) => void
    addNewEmptyRecord?: () => void
    recordsSelectedCount: number
    deleteRecordsSelected?: () => Promise<void>
    onFieldCreated?: (field: FieldDto) => void
    records: RecordDto[]
    isTrashMode: boolean
    setIsTrashMode: (enabled: boolean) => void
    restoreRecordsSelected?: () => Promise<void>
    dataConnection?: DataConnectionDto
    isFiltersPaneOpen: boolean
    setIsFiltersPaneOpen: (open: boolean | ((prev: boolean) => boolean)) => void
}

export const ToolbarContext = createContext<ToolbarContextValue | null>(null)

export const useToolbarContext = (): ToolbarContextValue => {
    const context = useContext(ToolbarContext)
    if (!context) {
        throw new Error('useToolbarContext must be used within a ToolbarContextProvider')
    }

    return context
}
